import { UIProvider } from "moh-ui";
import { Toaster } from "react-hot-toast";
import { BrowserRouter as Router } from "react-router-dom";
import { RecoilRoot } from "recoil";
import AppRoutes from "./AppRoutes";
import ErrorBoundary from "./components/HOCs/errorBoundary";
import { AuthProvider } from "./hooks/useAuth";
import "./styles/App.css";
import "@mantine/dates/styles.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
const queryClient = new QueryClient({});
import "@mantine/dates/styles.css"
import * as Sentry from '@sentry/react';

function App() {
  return (
    <Sentry.ErrorBoundary>
      <ErrorBoundary>
        <RecoilRoot>
          <UIProvider>
            <Toaster />
            <Router>
              <QueryClientProvider client={queryClient}>
                <AuthProvider>
                  <AppRoutes />
                </AuthProvider>
              </QueryClientProvider>
            </Router>
          </UIProvider>
        </RecoilRoot>
      </ErrorBoundary>
    </Sentry.ErrorBoundary >
  );
}

export default App;
